export default "__VITE_ASSET__OveUB2QY__";